module.exports = __webpack_public_path__ + "img/CHECK.5275f3fb.svg";